import { PagamentoStatus } from '.';

export class PagamentoResumoFinanceiroDto {
  status: PagamentoStatus;
  parcelas: number;
  total: number;
}
